export const pendingApprovalDesignsApiPageSelector = (state, page) => {
  return state.api.designs.team.pendingApproval.pages[page];
};

export const pendingApprovalDesignsApiSelector = (state, page) => {
  return state.api.designs.team.pendingApproval;
};
